import { Component, Input, OnDestroy } from '@angular/core';
import { MachineDto, ModalService, SimpleMessageService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Subscription } from 'rxjs';
import { TenantManagementService } from '../../services/tenant-management.service';

@Component({
    selector: 'oaibox-delete-machine-warning-modal',
    templateUrl: './delete-machine-warning-modal.component.html',
    styleUrls: ['./delete-machine-warning-modal.component.css'],
    imports: [WebAppCommonModule]
})
export class DeleteMachineWarningModalComponent implements OnDestroy {

  @Input() public tenant?: Tenant;
  @Input() public machine?: MachineDto;

  private deleteMachineSubscription?: Subscription;

  constructor(
    private simpleMessageService: SimpleMessageService,
    private tenantManagementService: TenantManagementService,
    private modalService: ModalService
  ) {
  }

  protected confirm(): void {
    if (this.tenant && this.machine) this.deleteMachineSubscription = this.tenantManagementService
      .deleteMachineFromTenant(this.tenant.id, this.machine.id)
      .subscribe({
        next: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'Machine deleted successfully!', icon: 'fa-solid fa-check-double', color: 'success'
          });
          this.tenantManagementService.refreshTenants();
          this.modalService.popModal();
        },
        error: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'Machine not deleted!', icon: 'fa-solid fa-triangle-exclamation', color: 'danger'
          });
          this.modalService.popModal();
        },
      });
  }

  protected cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.deleteMachineSubscription?.unsubscribe();
  }

}
